"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var CodebookLookupSequence_1 = require("../../core/model/codebook/CodebookLookupSequence");

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");

var utils_1 = require("../../core/utils");

var ForecastSimulationUpdateTypeEnum;

(function (ForecastSimulationUpdateTypeEnum) {
  ForecastSimulationUpdateTypeEnum["ACCEPT"] = "ACCEPT";
  ForecastSimulationUpdateTypeEnum["REJECT"] = "REJECT";
})(ForecastSimulationUpdateTypeEnum = exports.ForecastSimulationUpdateTypeEnum || (exports.ForecastSimulationUpdateTypeEnum = {}));

var ForecastSimulationUpdateDTO =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(ForecastSimulationUpdateDTO, _DomainObject_1$Domai);

  /**
   * @param actionType
   * @param windowId
   * @param windowItemId
   * @param supplierAgreementId
   * @param windowTypeId
   * @param windowTypeNote
   * @param windowName
   * @param windowNameNote
   * @param regularPrice
   * @param regularPriceNote
   * @param promoPrice
   * @param promoPriceNote
   * @param promoVolume
   * @param promoVolumeNote
   * @param posMarginImpactTheoretical
   * @param posMarginImpactTheoreticalNote
   * @param posMechanics
   * @param posMechanicsNote
   * @param promoPurchasePrice
   * @param promoPurchasePriceNote
   * @param unitBackDiscount
   * @param unitBackDiscountNote
   * @param vaValue
   * @param vaValueNote
   */
  function ForecastSimulationUpdateDTO(actionType, windowId, windowItemId, supplierAgreementId, windowTypeId, windowTypeNote, windowName, windowNameNote, regularPrice, regularPriceNote, promoPrice, promoPriceNote, promoVolume, promoVolumeNote, posMarginImpactTheoretical, posMarginImpactTheoreticalNote, posMechanics, posMechanicsNote, promoPurchasePrice, promoPurchasePriceNote, unitBackDiscount, unitBackDiscountNote, vaValue, vaValueNote) {
    var _this;

    _classCallCheck(this, ForecastSimulationUpdateDTO);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ForecastSimulationUpdateDTO).call(this));
    _this.actionType = actionType;
    _this.windowId = windowId;
    _this.windowItemId = windowItemId;
    _this.supplierAgreementId = supplierAgreementId;
    _this.windowTypeId = windowTypeId;
    _this.windowTypeNote = windowTypeNote;
    _this.windowName = windowName;
    _this.windowNameNote = windowNameNote;
    _this.regularPrice = regularPrice;
    _this.regularPriceNote = regularPriceNote;
    _this.promoPrice = promoPrice;
    _this.promoPriceNote = promoPriceNote;
    _this.promoVolume = promoVolume;
    _this.promoVolumeNote = promoVolumeNote;
    _this.posMarginImpactTheoretical = posMarginImpactTheoretical;
    _this.posMarginImpactTheoreticalNote = posMarginImpactTheoreticalNote;
    _this.posMechanics = posMechanics;
    _this.posMechanicsNote = posMechanicsNote;
    _this.promoPurchasePrice = promoPurchasePrice;
    _this.promoPurchasePriceNote = promoPurchasePriceNote;
    _this.unitBackDiscount = unitBackDiscount;
    _this.unitBackDiscountNote = unitBackDiscountNote;
    _this.vaValue = vaValue;
    _this.vaValueNote = vaValueNote;
    return _this;
  }
  /**
   * Converter from data-dictionary representation
   */


  _createClass(ForecastSimulationUpdateDTO, [{
    key: "containsWindowChanges",
    value: function containsWindowChanges() {
      return !utils_1.Utils.isValueMissing(this.windowId);
    }
  }, {
    key: "containsWindowItemsChanges",
    value: function containsWindowItemsChanges() {
      return !utils_1.Utils.isValueMissing(this.windowItemId);
    }
  }], [{
    key: "fromDataDict",
    value: function fromDataDict(mat) {
      return new ForecastSimulationUpdateDTO(mat.actionType, mat.windowId, mat.windowItemId, mat.supplierAgreementId, mat.windowTypeId, mat.windowTypeNote, mat.windowName, mat.windowNameNote, mat.regularPrice, mat.regularPriceNote, mat.promoPrice, mat.promoPriceNote, mat.promoVolume, mat.promoVolumeNote, mat.posMarginImpactTheoretical, mat.posMarginImpactTheoreticalNote, mat.posMechanics, mat.posMechanicsNote, mat.promoPurchasePrice, mat.promoPurchasePriceNote, mat.unitBackDiscount, mat.unitBackDiscountNote, mat.vaValue, mat.vaValueNote);
    }
    /**
     * Reset Window simulation values
     */

  }, {
    key: "resetWindowSimulationValues",
    value: function resetWindowSimulationValues(windowId) {
      return new ForecastSimulationUpdateDTO().copyMulti({
        windowId: windowId,
        windowTypeId: null,
        windowTypeNote: null,
        windowName: null,
        windowNameNote: null
      });
    }
    /**
     * Reset WindowItem simulation values
     */

  }, {
    key: "resetWindowItemSimulationValues",
    value: function resetWindowItemSimulationValues(windowItemId) {
      return new ForecastSimulationUpdateDTO().copyMulti({
        windowItemId: windowItemId,
        regularPrice: null,
        regularPriceNote: null,
        promoPrice: null,
        promoPriceNote: null,
        promoVolume: null,
        promoVolumeNote: null,
        posMarginImpactTheoretical: null,
        posMarginImpactTheoreticalNote: null,
        posMechanics: null,
        posMechanicsNote: null,
        promoPurchasePrice: null,
        promoPurchasePriceNote: null,
        unitBackDiscount: null,
        unitBackDiscountNote: null,
        vaValue: null,
        vaValueNote: null
      });
    }
  }]);

  return ForecastSimulationUpdateDTO;
}(DomainObject_1.DomainObject);

exports.ForecastSimulationUpdateDTO = ForecastSimulationUpdateDTO;

ForecastSimulationUpdateDTO.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(ForecastSimulationUpdateDTO.name);
  return {
    actionType: builder.opt(builder.senum('actionType', ForecastSimulationUpdateTypeEnum, CodebookLookupSequence_1.CodebookLookupSequence.ForecastSimulationUpdateType)),
    windowId: builder.opt(builder.id('windowId')),
    windowItemId: builder.opt(builder.id('windowItemId')),
    supplierAgreementId: builder.opt(builder.id('supplierAgreementId')),
    windowTypeId: builder.opt(builder.str('windowTypeId')),
    windowTypeNote: builder.opt(builder.str('windowTypeNote')),
    windowName: builder.opt(builder.str('windowName')),
    windowNameNote: builder.opt(builder.str('windowNameNote')),
    regularPrice: builder.opt(builder.bigNum('regularPrice')),
    regularPriceNote: builder.opt(builder.str('regularPriceNote')),
    promoPrice: builder.opt(builder.bigNum('promoPrice')),
    promoPriceNote: builder.opt(builder.str('promoPriceNote')),
    promoVolume: builder.opt(builder.bigNum('promoVolume')),
    promoVolumeNote: builder.opt(builder.str('promoVolumeNote')),
    posMarginImpactTheoretical: builder.opt(builder.bigNum('posMarginImpactTheoretical')),
    posMarginImpactTheoreticalNote: builder.opt(builder.str('posMarginImpactTheoreticalNote')),
    posMechanics: builder.opt(builder.str('posMechanics')),
    posMechanicsNote: builder.opt(builder.str('posMechanicsNote')),
    promoPurchasePrice: builder.opt(builder.bigNum('promoPurchasePrice')),
    promoPurchasePriceNote: builder.opt(builder.str('promoPurchasePriceNote')),
    unitBackDiscount: builder.opt(builder.bigNum('unitBackDiscount')),
    unitBackDiscountNote: builder.opt(builder.str('unitBackDiscountNote')),
    vaValue: builder.opt(builder.bigNum('vaValue')),
    vaValueNote: builder.opt(builder.str('vaValueNote'))
  };
}();